import { BankCreate } from './BankCreate'
import { BankEdit } from './BankEdit'
import { BankList } from './BankList'
import { BankShow } from './BankShow'

export { BankCreate, BankEdit, BankList, BankShow }
